module.exports = __webpack_public_path__ + "static/tegus-logo-e60016be183c30c00bb3ce4e208edb35.jpg";